import theme from "../../theme";
export var useTooltipTypeList = function useTooltipTypeList() {
  var _theme$useToken = theme.useToken(),
    token = _theme$useToken.token;
  return [{
    type: 'success',
    color: token.colorSuccess,
    backgroundColor: token.colorSuccessBg
  }, {
    type: 'info',
    color: token.colorInfo,
    backgroundColor: token.colorInfoBg
  }, {
    type: 'warning',
    color: token.colorWarning,
    backgroundColor: token.colorWarningBg
  }, {
    type: 'error',
    color: token.colorError,
    backgroundColor: token.colorErrorBg
  }];
};